import { render, staticRenderFns } from "./CdaRedesDialog.vue?vue&type=template&id=0d1a2f6c&scoped=true&"
import script from "./CdaRedesDialog.vue?vue&type=script&lang=js&"
export * from "./CdaRedesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1a2f6c",
  null
  
)

export default component.exports